import { gql } from '@apollo/client'

export const GET_APPRAISAL_SEASON_OPENING_INFO = gql`
  query GetAppraisalSeasonOpeningInfo($companyId: HashedId!, $country: Country!) {
    getAppraisalSeasonOpeningInfo(companyId: $companyId, country: $country) {
      defaultAppraisalSeasonOpeningMonth
      defaultCountryTimezone
      currentAppraisalSeasonOpeningMonth
      currentAppraisalSeasonOpeningYear
      nextAppraisalSeasonOpeningMonth
      nextAppraisalSeasonOpeningYear
      currentAppraisalSeasonYear
      nextAppraisalSeasonYear
    }
  }
`
